import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { sidebarWidth } from 'themes/layout';

export const StyledBackgroundBox = styled(Box)({
  background: 'rgba(0,0,0, 0.5)',
  width: '100vw',
  height: '100vh',
  zIndex: 0,
  position: 'absolute',
});

export const StyledMenuItemsBox = styled(Box)({
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
  paddingTop: '8px',
  zIndex: 1,
});

export const StyledMenuToggleButtonBox = styled(Box)(({ theme }) => ({
  boxShadow: `inset 0px 1px 0px ${theme.palette.divider}`,
}));

type MenuBaseProps = React.HTMLAttributes<HTMLDivElement> & {
  isClosed: boolean;
};

export const MenuBaseStyled = styled('div')<MenuBaseProps>(({ theme, isClosed }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginRight: '1em',
  height: '100%',
  width: sidebarWidth,
  flexGrow: 0,
  position: 'relative',
  backgroundColor: theme.palette.background.default,
  ...(isClosed && {
    width: '64px',
    backgroundColor: theme.palette.tableHead,
  }),
}));
